import { useCallback, useEffect, useState } from "react";
import expenseService from "../services/expenseService";
import notify from "../../../services/notify.js";



const useExpenseFormLoad = (expenseId) => {

    const [expense, setExpense] = useState(null);

    const [loading, setLoading] = useState(false);

    //----------------------------------------------------

    const loadExpense = useCallback(async () => {

        if (!expenseId) {

            return;

        }

        try {

            setLoading(true);

            const result = await expenseService.getExpense(

                expenseId

            );

            setExpense(result);

        }

        catch (error) {

            console.error(error);

            notify.error(error);

        }

        finally {

            setLoading(false);

        }

    }, [expenseId]);

    //----------------------------------------------------

    useEffect(() => {

        loadExpense();

    }, [loadExpense]);

    //----------------------------------------------------

    return {

        expense,

        loading,

        reload: loadExpense,

    };

};

export default useExpenseFormLoad;